'use strict'
import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM'

export class TopTeamsParticipants{
    #navContainer
    #topsContainer
    constructor() {
        this.#topsContainer = DOM.el('.wp-block-custom-team-campaign-top-donors-top-participants-levit-block');
        this.#navContainer = DOM.el('.top-navigation-mobile', this.#topsContainer)
        if (this.#topsContainer && this.#navContainer) {
            this.#handleNavButton();
        }
    }

    #handleNavButton(){
        const recentDonationsButton = DOM.el('.recent-donations-nav');
        const topParticipantsButton = DOM.el('.top-participants-nav');
        const topTeamsContainer = DOM.el('.top-teams-container', this.#topsContainer);
        const topParticipantsContainer = DOM.el('.top-participants-container', this.#topsContainer);
        const topDonationsContainer = DOM.el('.top-donations-container', this.#topsContainer);

        function setContainers({showTeams, showDonations, showParticipants}) {
            if (showTeams) {
                topTeamsContainer.classList.remove('fade-slide-hidden');
                topTeamsContainer.classList.add('fade-slide-visible');
            } else {
                topTeamsContainer.classList.add('fade-slide-hidden');
                topTeamsContainer.classList.remove('fade-slide-visible');
            }
            if (showDonations) {
                topDonationsContainer.classList.remove('fade-slide-hidden');
                topDonationsContainer.classList.add('fade-slide-visible');
            } else {
                topDonationsContainer.classList.add('fade-slide-hidden');
                topDonationsContainer.classList.remove('fade-slide-visible');
            }
            if (showParticipants) {
                topParticipantsContainer.classList.remove('fade-slide-hidden');
                topParticipantsContainer.classList.add('fade-slide-visible');
            } else {
                topParticipantsContainer.classList.add('fade-slide-hidden');
                topParticipantsContainer.classList.remove('fade-slide-visible');
            }
        }

        if (window.innerWidth <= 768) {
            setContainers({showTeams: true, showDonations: true, showParticipants: false});
        }

        DOM.addEvent('click', recentDonationsButton, () => {
            setContainers({showTeams: true, showDonations: true, showParticipants: false});

            recentDonationsButton.style.backgroundColor = 'white';
            recentDonationsButton.style.color = '#0076A3';
            topParticipantsButton.style.backgroundColor = '#0076A3';
            topParticipantsButton.style.color = 'white';
        })

        DOM.addEvent('click', topParticipantsButton, () => {
            setContainers({showTeams: false, showDonations: false, showParticipants: true});

            topParticipantsButton.style.backgroundColor = 'white';
            topParticipantsButton.style.color = '#0076A3';
            recentDonationsButton.style.backgroundColor = '#0076A3';
            recentDonationsButton.style.color = 'white';
        })
    }
}
